import { fetchApi } from '@/config/axiosSetting';
import { HomePageAlertQueryResponseType } from '@/modules/Dashboard/queries/homePageAlert/homePageAlertQuery.type';

export const homePageAlertFunction =
  (): Promise<HomePageAlertQueryResponseType> => {
    return fetchApi.get('homepage/alert/');
  };
